import { useCallback } from 'react';
import { useClerk } from '@clerk/clerk-react';

import { clearSession, clearToken } from '@/utils/session';

export function useSignOut(): () => Promise<void> {
  const { signOut } = useClerk();

  return useCallback(async () => {
    clearToken();
    clearSession();
    await signOut({ redirectUrl: '/' });
  }, [signOut]);
}
